import type { SortOrder } from 'antd/es/table/interface';

interface SorterParams {
  field?: string;
  order?: 'asc' | 'desc' | null;
}

export const getSortOrder = (
  currentField: string,
  sorter?: SorterParams
): SortOrder => {
  if (!sorter || sorter.field !== currentField) return null;

  switch (sorter.order) {
    case 'asc':
      return 'ascend';
    case 'desc':
      return 'descend';
    default:
      return null;
  }
};
